import { clsx } from 'clsx';
import { isNil, upperFirst } from 'lodash-es';

import styles from '../../styles/element.module.scss';

export const boxShadows = [
  'focused',
  'error',
  'elevationNearest',
  'elevationNearer',
  'elevationNear',
  'elevationFar',
  'elevationFurther',
  'elevationFurthest',
  'elevationInvertedFurthest',
  'paperOutline',
  'paperElevationOne',
  'paperTwoOutline',
  'paperTwoElevationOne'
] as const;

export type BoxShadows = (typeof boxShadows)[number];

export interface BoxShadowProps {
  boxShadow?: BoxShadows;
}

export const boxShadowClassNames = (
  styles: Record<string, string>,
  propValue: BoxShadows | undefined
) => {
  const classNames: Record<string, boolean> = {};

  if (!isNil(propValue)) {
    classNames[
      styles[`boxShadow${upperFirst(propValue)}`] as keyof typeof classNames
    ] = true;
  }

  return classNames;
};

export const boxShadowHelpers = {
  defaultProps: {
    boxShadow: undefined
  },
  classnames: (props: BoxShadowProps): string => {
    return clsx(boxShadowClassNames(styles, props.boxShadow));
  },
  base: ({ boxShadow, ...props }: BoxShadowProps & unknown) => props
};
